// import { Play, Settings } from "lucide-react"
import { useState } from 'react'
import {
  Area,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select"
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { Label } from '@/components/ui/label'

// Mock data - replace with real data from your API
const deliverabilityData = [
  { time: '06 Feb', value: 0.4 },
  { time: '07 Feb', value: 0.3 },
  { time: '08 Feb', value: 0.5 },
  { time: '09 Feb', value: 0.7 },
  { time: '10 Feb', value: 0.4 },
  { time: '11 Feb', value: 0.6 },
  { time: '12 Feb', value: 0.8 },
]

// interface MailboxDetailsProps {
//   mailbox: {
//     email: string;
//     dnsScore: number;
//     sentToday: number;
//     totalSent: number;
//     receivedToday: number;
//     totalReceived: number;
//     inboxRate: number;
//     spamRate: number;
//     bounceRate: number;
//   }
//   onClose: () => void;
// }

export const Route = createFileRoute('/_private/mailboxes/detail')({
  component: MailboxDetails,
  loader: async ({ params: { id } }: { params: { id: string } }) => {
    console.log(id, 'id')
    return { mailboxId: id }
  },
})

export function MailboxDetails() {
  //   const { mailboxId } = Route.useLoaderData()
  const navigate = useNavigate()
  const [activeTab, setActiveTab] = useState('deliverability')

  return (
    <>
      <div className="w-full">
        <div className="container flex items-center justify-center h-full">
          <div className="w-full max-h-[90vh] overflow-y-auto bg-background rounded-lg ">
            <div className="flex justify-between items-center mb-6">
              <h2 className="text-2xl font-bold">Mailbox Details</h2>
              <Button
                variant="ghost"
                onClick={() => navigate({ to: '/mailboxes' })}
              >
                ×
              </Button>
            </div>

            {/* Configuration Options */}
            <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-6">
              <div className="space-y-2">
                <Label>Email:</Label>
                <div className="text-sm font-medium">test@test.com</div>
              </div>
              {/* Add more configuration fields as needed */}
            </div>

            {/* Stats Cards */}
            <div className="grid gap-4 md:grid-cols-3 mb-6">
              <Card>
                <CardHeader className="pb-2">
                  <CardTitle className="text-sm">Sent Today</CardTitle>
                </CardHeader>
                {/* <CardContent>
                  <div className="text-2xl font-bold">{mailbox.sentToday}</div>
                  <div className="text-xs text-muted-foreground">Total: {mailbox.totalSent}</div>
                </CardContent> */}
              </Card>
              {/* Add more stat cards */}
            </div>

            {/* Main Content */}
            <div className="grid gap-4 md:grid-cols-2">
              <Card className="md:col-span-2">
                <CardHeader>
                  <CardTitle>Deliverability Metrics</CardTitle>
                </CardHeader>
                <CardContent>
                  <Tabs value={activeTab} onValueChange={setActiveTab}>
                    <TabsList>
                      <TabsTrigger value="deliverability">
                        Deliverability
                      </TabsTrigger>
                      <TabsTrigger value="activity">Activity</TabsTrigger>
                    </TabsList>
                    <TabsContent value="deliverability">
                      <div className="h-[300px] pt-4">
                        <ResponsiveContainer width="100%" height="100%">
                          <AreaChart data={deliverabilityData}>
                            <XAxis dataKey="time" />
                            <YAxis />
                            <Tooltip />
                            <Area
                              type="monotone"
                              dataKey="value"
                              stroke="#2563eb"
                              fill="#bfdbfe"
                            />
                          </AreaChart>
                        </ResponsiveContainer>
                      </div>
                    </TabsContent>
                  </Tabs>
                </CardContent>
              </Card>

              {/* Add DNS Score and Email Test cards */}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
